/* eslint-disable no-shadow */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { I18n } from 'react-redux-i18n';

import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { getAuthUser, unauth } from '../../redux/actions/authActions';
import { setLanguage } from '../../redux/actions/userActions';

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  setLanguage,
  unauth,
};

const drawerWidth = 240;
const innerStyles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
  },
  flex: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
});

class Header extends React.Component {

  static propTypes = {
    styles: PropTypes.object,
    handleChangeRequestNavDrawer: PropTypes.func,
    setLanguage: PropTypes.func.isRequired,
    locale: PropTypes.string,
  };

  constructor(props) {

    super(props);
    this.state = {
      logoutModalOpen: false,
      languageMenu: null,
      exitMenu: null,
    };
    this.onClickLogout = this.onClickLogout.bind(this);
    this.logout = this.logout.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.setLanguageBR = this.setLanguageBR.bind(this);
    this.setLanguageEN = this.setLanguageEN.bind(this);
    this.myAccount = this.myAccount.bind(this);
    this.changeContext = this.changeContext.bind(this);

    const user = getAuthUser();
    if (user)
      this.currentProgram = user.currentProgram;

  }

  onClickLogout(event) {

    event.preventDefault();
    this.setState({
      logoutModalOpen: true,
    });

  }

  logout(event) {

    event.preventDefault();
    this.props.history.push('/logout');
    setTimeout(() => {

      this.props.unauth();
      this.props.history.push('/login');

    }, 2000);

  }

  myAccount(event) {

    const { router } = this.props;

    event.preventDefault();

    router.push('my-account');

  }

  changeContext(event) {

    const router = this.props;

    event.preventDefault();

    router.history.push('/context');

  }

  setLanguageBR() {

    const { setLanguage } = this.props;
    setLanguage('pt_BR');
    setTimeout(window.location.reload, 500);

  }

  setLanguageEN() {

    const { setLanguage } = this.props;
    setLanguage('en');

  }

  handleClose() {

    this.setState({
      logoutModalOpen: false,
    });

  }

  renderTitle = () => `${I18n.t('application.title')} - Programa`;

  render() {

    const { classes, styles, handleChangeRequestNavDrawer } = this.props;
    const { languageMenu, exitMenu } = this.state;

    const languageImage = `/images/${this.props.locale}.png`;

    const style = {
      appBar: {
        position: 'fixed',
        top: 0,
        overflow: 'hidden',
        maxHeight: 57,
      },
      menuButton: {
        marginLeft: 10,
      },
      iconsRightContainer: {
        marginLeft: 20,
      },
    };


    const logoutActions = [
      <Button
      variant="contained"
      color="primary"
      autoFocus
      onClick={this.handleClose}
    >
      Não
    </Button>,
      <Button
        variant="contained"
        color="secondary"
        onClick={this.logout}
      >
      Sim
      </Button>,
    ];

    return (
      <div>
        <AppBar
          position="absolute"
          style={{ ...styles, ...style.appBar }}
          title={this.renderTitle()}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              className={classes.menuButton}
              aria-label="Menu"
              onClick={handleChangeRequestNavDrawer}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="title" color="inherit" className={classes.flex}>
              &nbsp;
            </Typography>
            <div>
              <IconButton
                color="inherit"
                aria-owns={exitMenu ? 'simple-menu' : null}
                aria-haspopup="true"
                onClick={ev => this.setState({ exitMenu: ev.currentTarget })}
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                open={Boolean(exitMenu)}
                anchorEl={exitMenu}
                onClose={() => this.setState({ exitMenu: null })}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <MenuItem onClick={this.onClickLogout}>
                  <span>Sair</span>
                </MenuItem>
                <MenuItem onClick={this.changeContext}>
                  <span>Alterar Contexto</span>
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
          <Dialog
            modal
            open={this.state.logoutModalOpen}
            onRequestClose={this.handleClose}
          >
            <DialogTitle id="alert-dialog-title">{'Deseja realmente sair?'}</DialogTitle>
            <DialogActions>
              {logoutActions}
            </DialogActions>
          </Dialog>
        </AppBar>
      </div>
    );

  }

}

export default withStyles(innerStyles)(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Header)
));



// WEBPACK FOOTER //
// ./src/app/header/Header.js